<template>
  <div v-loading="loading">
    <div class="tx-c m-b-10">人力资源类数据统计</div>
    <el-table
      :data="tableData"
      border
      style="width: 100%">
      <el-table-column
        prop="status"
        label="工作状态"
        fixed="left"
        width="200">
      </el-table-column>
      <el-table-column label="统计对象">
        <el-table-column
          prop="profession"
          label="职称类证书"
          width="200">
        </el-table-column>
        <el-table-column
          prop="register"
          label="注册类证书"
          width="200">
        </el-table-column>
        <el-table-column
          prop="five_people"
          label="五大员证书"
          width="200">
        </el-table-column>
        <el-table-column
          prop="middle_level"
          label="中级工证书"
          width="200">
        </el-table-column>
        <el-table-column
          prop="special"
          label="特种工证书"
          width="200">
        </el-table-column>
        <el-table-column
          prop="three_kinds"
          label="三类人员证书"
          width="200">
        </el-table-column>
        <el-table-column
          prop="all"
          label="合计"
          min-width="200">
        </el-table-column>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
  import http from '../../assets/js/http'
  export default {
    iden: 'humanSource',
    data() {
      return {
        tableData: [],
        loading: false
      }
    },
    created() {
      this.getData()
    },
    methods: {
      async getData() {
        this.loading = true
        let res = await this.apiGet('statistic/project/get_hrresource_count')
        let data = this.promiseHandler(data, res)
        this.tableData = data
        this.loading = false
      }
    },
    mixins: [http]
  }
</script>


// WEBPACK FOOTER //
// humanSource.vue?25018eb3